export default class FilterPrice {

    async init(): Promise<void> {
        jQuery(document).on('ajaxComplete', () => this.filterPrice());
    }

    async filterPrice(): Promise<void> {
        const filterMinInput: HTMLInputElement | null = document.querySelector('.wcapf-range-number input.min-value');
        const filterMaxInput: HTMLInputElement | null = document.querySelector('.wcapf-range-number input.max-value');

        if (!filterMinInput || !filterMaxInput) return;

        filterMinInput.blur();
        filterMaxInput.blur();
    }
}